import { redirect } from '@tanstack/react-router'
import type { RouterContext } from '@/app/router/router'
import type { SupportedLanguage } from '@/shared/i18n/supported-languages'
import {
  DEFAULT_LANGUAGE,
  isSupportedLanguage,
} from '@/shared/i18n/supported-languages'

type RouteLangParams = {
  lang?: unknown
}

function resolveLang(params: RouteLangParams | undefined): SupportedLanguage {
  const candidate = params?.lang
  return isSupportedLanguage(candidate) ? candidate : DEFAULT_LANGUAGE
}

export function requireAuthenticated(
  context: RouterContext,
  params?: RouteLangParams,
  redirectTo?: string,
): void {
  if (context.auth.status === 'PENDING') {
    return
  }

  if (context.auth.status === 'AUTHENTICATED') {
    return
  }

  throw redirect({
    to: '/$lang/login',
    params: { lang: resolveLang(params) },
    search:
      redirectTo && redirectTo.startsWith('/')
        ? { redirect: redirectTo }
        : undefined,
  })
}

export function redirectAuthenticatedToHome(
  context: RouterContext,
  params?: RouteLangParams,
): void {
  if (context.auth.status !== 'AUTHENTICATED') {
    return
  }

  throw redirect({
    to: '/$lang/app',
    params: { lang: resolveLang(params) },
  })
}
